import { RouteRecordRaw } from 'vue-router'
import Layout from '@/components/layout/index.vue'

const UserManagerRouter: Array<RouteRecordRaw> = [

    {
        path: '/error',
        component: Layout,
        redirect: 'noredirect',
        children: [
          {
            path: '401',
            component: () => import('@/views/error/401.vue'),
            name: 'error_401',
          }
        ]
    }
]
export default UserManagerRouter
